import { useTranslation } from 'react-i18next';

import {
  HourlyRateModels,
  ProjectTaskStatuses,
  TaskBillingTypes,
} from '@/api/REST/projects';
import type {
  HourlyRateModel,
  ProjectTaskStatus,
  TaskBillingType,
} from '@/api/REST/projects';

export const usePlanningLabels = () => {
  const { t } = useTranslation('projectManagement');

  const billingTypeLabels: Record<TaskBillingType, string> = {
    [TaskBillingTypes.FixedPriceProject]: t(
      'TaskBillingType.FixedPriceProject',
    ),
    [TaskBillingTypes.FixedPriceTask]: t('TaskBillingType.FixedPriceTask'),
    [TaskBillingTypes.TimeAndMaterial]: t('TaskBillingType.TimeAndMaterial'),
  };

  const taskStatusLabels: Record<ProjectTaskStatus, string> = {
    [ProjectTaskStatuses.NotStarted]: t('TaskStatus.NotStarted'),
    [ProjectTaskStatuses.InProgress]: t('TaskStatus.InProgress'),
    [ProjectTaskStatuses.OnHold]: t('TaskStatus.OnHold'),
    [ProjectTaskStatuses.Completed]: t('TaskStatus.Completed'),
    [ProjectTaskStatuses.Cancelled]: t('TaskStatus.Cancelled'),
  };

  const hourlyRateModelLabels: Record<HourlyRateModel, string> = {
    [HourlyRateModels.Calculated]: t('HourlyRateModel.Calculated'),
    [HourlyRateModels.Allocated]: t('HourlyRateModel.Allocated'),
  };

  return { billingTypeLabels, taskStatusLabels, hourlyRateModelLabels };
};
